import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const AboutSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section
      id="about"
      ref={ref}
      data-testid="about-section"
      className="section-padding bg-[#FDFBF7]"
    >
      <div className="container-main">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center">
          {/* Left - Large Typography */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="md:col-span-5"
          >
            <h2
              className="text-6xl sm:text-7xl lg:text-8xl font-light leading-[0.95] text-[#0A192F]"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
              data-testid="about-headline"
            >
              15+
              <br />
              <span className="text-4xl sm:text-5xl lg:text-6xl text-[#4A5568]">
                Years of
                <br />
                Leadership
                <br />
                Experience
              </span>
            </h2>
          </motion.div>

          {/* Right - Bio and Image */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="md:col-span-7"
          >
            <div className="relative">
              {/* Image */}
              <div className="relative mb-8 md:mb-0 md:absolute md:-top-20 md:right-0 md:w-64 lg:w-80 z-10">
                <img
                  src="https://images.unsplash.com/photo-1623594675959-02360202d4d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjB3b21hbiUyMHBvcnRyYWl0fGVufDB8fHx8MTc3NDk3MDc4MXww&ixlib=rb-4.1.0&q=85"
                  alt="Susana - Leadership Advisor"
                  className="w-full aspect-[3/4] object-cover rounded-lg shadow-xl"
                  data-testid="about-portrait"
                />
              </div>

              {/* Text Content */}
              <div className="md:pr-72 lg:pr-88">
                <p className="overline text-[#7A8B71] mb-4" data-testid="about-overline">
                  About Susana
                </p>
                
                <p className="body-large text-[#4A5568] mb-6" data-testid="about-text-1">
                  With over 15 years of experience in corporate environments, I've seen 
                  firsthand the challenges leaders and teams face — from high pressure 
                  and burnout to lack of clarity and alignment.
                </p>
                
                <p className="body-text text-[#4A5568] mb-6" data-testid="about-text-2">
                  Today, I work with leaders, founders, and organizations to build 
                  sustainable, high-performing teams by integrating leadership development 
                  with workplace well-being.
                </p>
                
                <p className="body-text text-[#4A5568]" data-testid="about-text-3">
                  My approach combines strategic thinking, human-centered leadership, 
                  and proven frameworks to help individuals and organizations thrive — 
                  not just perform.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
